export const GRAPHQL_FILE_UPLOAD_LIMIT_ERROR_CODE = "FileUploadLimitReached";
export const GRAPHQL_FILE_UPLOAD_FORBIDDEN_ERROR_CODE = "FileUploadForbidden";
